import React from "react";
import { ConfigStage, PromptStage, StageSelector } from "./components";
import styles from "./ConfigurationTab.module.css";
import { isNonEmptyArray } from "../../../../../../../utils";

const ConfigurationTab = ({
	actionOption,
	actionOptions = [],
	actionOptionsTitle = "",
	documentOption,
	documentOptions = [],
	documentOptionsTitle = "",
	instructions = "",
	isTemplate = "",
	onChangeActionOption,
	onChangeDocumentOption,
	onChangeDocuments,
	onChangeInstructions,
	onChangeStage,
	promptHoverText = "",
	promptModelHelperText = "",
	promptModels,
	promptPlaceholder = "",
	promptTitle = "",
	selectedDocuments = {},
	stage,
	totalDocuments = 0,
}) => {
	const handleRenderStage = () => {
		if (stage === 0 && isNonEmptyArray(promptModels)) {
			return (
				<PromptStage
					instructions={instructions}
					promptModelHelperText={promptModelHelperText}
					promptModels={promptModels}
					onChangeInstructions={onChangeInstructions}
				/>
			);
		}
		return (
			<ConfigStage
				actionOption={actionOption}
				actionOptions={actionOptions}
				actionOptionsTitle={actionOptionsTitle}
				documentOption={documentOption}
				documentOptions={documentOptions}
				documentOptionsTitle={documentOptionsTitle}
				instructions={instructions}
				promptHoverText={promptHoverText}
				promptPlaceholder={promptPlaceholder}
				promptTitle={promptTitle}
				selectedDocuments={selectedDocuments}
				totalDocuments={totalDocuments}
				onChangeActionOption={onChangeActionOption}
				onChangeDocumentOption={onChangeDocumentOption}
				onChangeDocuments={onChangeDocuments}
				onChangeInstructions={onChangeInstructions}
			/>
		);
	};
	return (
		<div className={styles.container}>
			<StageSelector isTemplate={isTemplate} stage={stage} onChangeStage={onChangeStage} />
			{handleRenderStage()}
		</div>
	);
};

export default ConfigurationTab;
